export default __webpack_public_path__ + "static/media/smallMail.667ea213.svg";